export default __webpack_public_path__ + "static/media/day.f7d01384.jpg";